import { z } from 'zod';

// ---------------------------------------------------------------------------
// GET /v1/prices/min — canonical key: wallpaper_id (NOT materialId)
// G1: pricing semantic fix per api-freeze spec §4.G1
// ---------------------------------------------------------------------------

export const PriceMinRequestSchema = z.object({
  wallpaper_id: z.string().uuid(),
  width_cm: z.coerce.number().positive(),
  height_cm: z.coerce.number().positive(),
});
export type PriceMinRequest = z.infer<typeof PriceMinRequestSchema>;

export const PriceMinResponseSchema = z.object({
  wallpaper_id: z.string().uuid(),
  min_price_30d: z.string().nullable(),
  currency: z.string().length(3),
  captured_at: z.string().datetime(),
});
export type PriceMinResponse = z.infer<typeof PriceMinResponseSchema>;

// ---------------------------------------------------------------------------
// GET /v1/prices/active — returns currently active price
// ---------------------------------------------------------------------------

export const PriceActiveRequestSchema = z.object({
  wallpaper_id: z.string().uuid(),
  currency: z.string().min(3).max(3),
});
export type PriceActiveRequest = z.infer<typeof PriceActiveRequestSchema>;

export const PriceActiveResponseSchema = z.object({
  wallpaper_id: z.string().uuid(),
  price: z.string().nullable(),
  currency: z.string().length(3),
});
export type PriceActiveResponse = z.infer<typeof PriceActiveResponseSchema>;
